export default __webpack_public_path__ + "static/media/Order_03.ffa79e98.png";